import { useMemo } from 'react';

import { globalTranslation } from '../globalTranslation';
import { mergeTranslations } from '../utils/mergeTranslations';
import {
  Translation,
  useTranslation,
  UseTranslationResult,
} from './useTranslation';

type GlobalTranslation = (typeof globalTranslation)['en-US'];

export function useGlobalTranslation<
  T extends Record<string, string | Record<string, string>>,
>(data?: Translation<T>): UseTranslationResult<GlobalTranslation & T> {
  const mergedTranslation = useMemo(
    () => mergeTranslations(globalTranslation, (data || {}) as Translation<T>),
    [data],
  );

  return useTranslation(mergedTranslation);
}
